import { isMobile } from '@/scripts/helpers/features'
import { dimensions as cfg } from '@/scripts/config/settings'
import type { ResizerDimensions } from './index'

export function calculateDimensions(containerW: number, availableHeight: number): ResizerDimensions {
  const SCENE_W = cfg.MAX_WIDTH // e.g. 2010
  const SCENE_H = cfg.MAX_HEIGHT // e.g. 1050
  const MIN_W = 'MIN_WIDTH' in cfg && typeof cfg.MIN_WIDTH === 'number' ? cfg.MIN_WIDTH : Math.round(SCENE_W * 0.895)

  // Height-fit as the base (desktop never >1×)
  let scaleH = availableHeight > 0 ? availableHeight / SCENE_H : 0
  if (!isMobile) scaleH = Math.min(scaleH, 1)
  if (!isFinite(scaleH) || scaleH < 0) scaleH = 0

  // Dynamic band start scales with height
  const bandStart = Math.round(MIN_W * scaleH)

  // Choose mode:
  // - If container is at least as wide as bandStart → height-lock (side crop allowed)
  // - Else scale down with width BUT keep side crop (stageW > containerW)
  let scale: number
  if (containerW >= bandStart) {
    scale = scaleH
  } else {
    const scaleW = MIN_W > 0 ? containerW / MIN_W : 0
    scale = Math.max(0, Math.min(scaleH, scaleW))
  }

  // Final stage size (strict 16:9)
  const stageW = Math.round(SCENE_W * scale)
  const stageH = Math.round(SCENE_H * scale)

  // Report back
  const stageX = 0
  const stageY = 0
  const containerR = containerW / (stageH || 1)

  return { containerW, containerH: stageH, containerR, scale, stageW, stageH, stageX, stageY }
}
